export const isPorter = (user) => {
   return Array.isArray(user?.porterDealerships) && user.porterDealerships.length > 0;
};

export const isDealerAdmin = (user) => {
   return Array.isArray(user?.adminDealerships) && user.adminDealerships.length > 0;
};

export const porterHomePath = (user) => {
   if (isDealerAdmin(user)) {
      return '/trip-list';
   }
   if (isPorter(user)) {
      return '/driver-home';
   }
   return '/';
};

export const porterDeniedPath = (user) => {
   if (isDealerAdmin(user)) {
      return '/trip-list';
   }
   return '/';
};
